import z from '@/lib/zod';
import { INFRASTRUCTURE_COSTS_TABS } from '@/pages/admin/infrastructure-costs/lib/infrastructure-costs-tabs';
import {
  optionalSearchInteger,
  optionalSearchString,
} from './search-param-schemas';

/**
 * Costi e piani (`/admin/infrastructure-costs`, `/referrer/...`): il tab
 * della pagina e i pannelli aperti (`plan` = «Modifica piano», `item` =
 * voce di costo, `item=new` = nuova voce, `offer=edit` = editor della
 * proposta; `lib/infrastructure-costs-panels.ts`).
 * Un tab scritto a mano diventa «nessun tab» (il default, «Piani e
 * marginalità») invece di far cadere la rotta.
 *
 * `plan` è l'id numerico del piano e resta un numero: letto come stringa,
 * il router lo riscriveva fra virgolette (`?plan=%2211%22`).
 */
export const infrastructureCostsSearchSchema = z.object({
  tab: z.enum(INFRASTRUCTURE_COSTS_TABS).optional().catch(undefined),
  plan: optionalSearchInteger(),
  item: optionalSearchString(),
  offer: optionalSearchString(),
});

export type InfrastructureCostsSearch = z.output<
  typeof infrastructureCostsSearchSchema
>;
